export const isDev = import.meta.env.VITE_ENVIRONMENT === "dev";
